import LoadingSpinner from "components/LoadingSpinner";
import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import { FILE_CONTENT_TYPE } from "static/constants";
import { useSelector } from "react-redux";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const PreviewModal = ({ isModalOpen, onClose, isLoading, actionButtons }) => {
  const [fileUrl, setFileUrl] = useState();
  const [isPDF, setIsPDF] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const { file } = useSelector((state) => state.patientProfileDocument);

  useEffect(() => {
    if (!isLoading) {
      const { url, type } = file;

      setIsPDF(type === FILE_CONTENT_TYPE.PDF);
      setFileUrl(url);
    }
  }, [file]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <ModalWrapper
      title="Document Preview"
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      showContentDivider
      actionButtons={actionButtons}
    >
      <div className="upload-modal__wrapper">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="printable-section">
              {!isPDF && fileUrl && <img src={fileUrl} alt="File Preview" />}
              {isPDF && fileUrl && (
                <div>
                  <Document
                    file={fileUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading="Loading PDF..."
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </ModalWrapper>
  );
};

export default PreviewModal;
